import { FormGroup } from '@angular/forms';
import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { getIP } from "src/app/modules/jobseeker-registration/services/registration/jobseeker-registration.service";
import { OnboardingManagerService } from "src/app/modules/my-journey/components/onboarding-manager/services/onboarding-manager.service";
import { ConfirmationComponent } from "src/app/modules/shared/confirmation/confirmation.component";
import { SessionService } from "src/app/services/session/session.service";
import { jsonParse } from "../../functions/shared-functions";
import { FilesService } from 'src/app/services/shared/files/files.service';
import { viewDocument } from "../files/files.component";
import { NotificationService } from "src/app/services/shared/notification/notification.service";
import { Subscription } from 'rxjs';
import { ProfileSettingsService } from 'src/app/services/shared/profile-settings/profile-settings.service';

var crypto = require('crypto');
var forge = require('node-forge');
forge.options.usePureJavaScript = true;
const pako = require('pako');
const aKey = 'T@MiCr097124!iCR';
var algorithm = 'aes-256-cbc';
var iv = "1234567891234567";
@Component({
  selector: 'tm-files-v2',
  templateUrl: './icr-file.component.html',
  styleUrls: ['./icr-file.component.scss'],
  providers: [FilesService, OnboardingManagerService]
})
export class IcrFileComponent implements OnInit, OnChanges {
  @Input() multiple;
  @Input() result = [];
  @Input() file_types;
  @Input() aspectRatio;
  @Input() final;
  @Input() crop;
  @Output() returnFiles = new EventEmitter();
  @Output() uploadStatus = new EventEmitter();
  @Input() flag;
  @Input() label;
  @Input() placeholder;
  @Input() required;
  @Input() max_fieldwidth_px;
  @Input() style;
  @Input() accept_file_type;
  @Input() form_group: FormGroup;
  @Input() form_control;
  @Input() server_filename = "a_fn";
  @Input() server_cdnpath = "a_url";
  @Input() save_filename = "fileName";
  @Input() save_cdnpath = "cdnPath";
  @Input() data;
  @Input() resume_parser = 0;
  @Input() label_visible = 0;
  @Input() extra_control_name
  @Input() manual_upload = 0;
  @Input() all_supported = false;
  @Input() disabled = 0;
  @Input() design_pattern = 1;
  @Input() cssClass
  @Input() dropdown_position = 1; // 1 bottom ,2 top
  @Input() supported_files = ['pdf', 'doc', 'docx', 'jpeg', 'png', 'jpg', 'xlsx', 'xlsm', 'jfif', 'mp3', "ogv", "wav", "amr", "ogg", "xls", "svg", "gif"]
  @Input() sample_download_ref;
  @Input() sample_download_ref_label = 'Click here to download sample format'
  @Input() UIValidationObjStruct;
  @Input() field_deatails;
  @Input() alertId;
  @Input() shortCode
  @Input() file_size_validation = {
    "unit": "MB",
    "size": "10"
  }
  storage_url = 'https://storage.googleapis.com/ezeone/icanrefer/';

  selected_files = []
  result_dimentions
  imageChangedEvent: any = '';
  width;
  height;
  uploadingStatus = 0;
  top = 0;
  left = 0;
  is_display_top = 0;
  container_width = 360;
  id: any = 'tm-files-v2-' + Math.floor((Math.random() * 1000) + 1);

  constructor(
    private file_service: FilesService,
    private dialog: MatDialog,
    private notification_srv: NotificationService,
    private onb_svc: OnboardingManagerService,
    private session_srv: SessionService,
    private profile_settings_srv: ProfileSettingsService

  ) { }

  ngOnInit() {
    if (this.form_group.get(this.form_control).value && typeof this.form_group.get(this.form_control).value == 'object' && this.form_group.get(this.form_control).value.length) {
      this.result = this.form_group.get(this.form_control).value
    }
  }
  ngOnChanges(ev) {
    console.log(ev)
    if (ev && ev.result) {
      if (typeof ev.result.currentValue == "string") {
        this.result = jsonParse(ev.result.currentValue) || [];
      }
      else {
        this.result = ev.result.currentValue || [];
      }
    }
    if (ev && ev.data) {
      this.data = ev.data.currentValue;
      if (typeof this.data == 'string') {
        try {
          this.data = JSON.parse(this.data)
          this.result = this.data || [];
        }
        catch (err) {
          console.log(err)
          let obj = {}
          if (this.data && this.data != '' && this.data != ' ') {
            obj[this.save_cdnpath] = this.data;
            obj[this.save_filename] = this.data;
            this.result = [obj];
          }

        }
      } else if (typeof this.data == 'object') {
        this.result = this.data || [];
      }
      else {
        this.result = [];
      }
    }
  }

  ngAfterViewInit(): void {
    if (this.form_group.get(this.form_control).value && typeof this.form_group.get(this.form_control).value == 'object' && this.form_group.get(this.form_control).value.length) {
      this.result = this.form_group.get(this.form_control).value
    }

  }

  fileInputChanged(files) {
    let valid_files = [];
    if (!this.uploadingStatus) {
      console.log(files)
      if (files && files.length > 20) {
        this.notification_srv.success('Please wait while valid attachment list is being prepared', 'Close', 5000)
      }
      if (this.UIValidationObjStruct && this.UIValidationObjStruct.maxFileCount && this.UIValidationObjStruct.maxFileCount.value) {
        if ((this.UIValidationObjStruct.maxFileCount.value < (files.length + (this.form_group.get(this.form_control).value ? this.form_group.get(this.form_control).value.length : 0)))) {
          this.notification_srv.error('Maxium length ' + this.UIValidationObjStruct.maxFileCount.value + ' has exceeded.', 'Close', 5000);
          return;
          // files.splice(this.UIValidationObjStruct.maxFileCount.value, (files.length - this.UIValidationObjStruct.maxFileCount.value));
        }

      };

      if (this.shortCode && this.shortCode.validationScriptUI && this.shortCode.validationScriptUI.runTimeScript) {
        let user_details = this.session_srv.getSessionData()
        let ip_obj = getIP();
        let cr = this;
        if (user_details && user_details.token && ip_obj) {
          let token = user_details.token;
          let ip = ip_obj.ip.toString();
          let region = ip_obj.region.toString();
          let timestamp: any = Date.now();
          timestamp = timestamp.toString();
          let lngId = localStorage.getItem('lngId') || '1';
          let hash = crypto.createHash('sha512')
            .update(timestamp + ip + region + token)
            .digest('hex');
          eval(this.shortCode.validationScriptUI.runTimeScript)


          // https://apisit.piramal.com/oauth/v1/cc/accesstoken%27
          // try {
          //   const xhr = new XMLHttpRequest(); xhr.open("POST", "https://jsonplaceholder.typicode.com/todos");
          //   xhr.setRequestHeader("Content-Type", "application/json; charset=UTF-8");
          //   const body = JSON.stringify({ userId: 1, title: "Fix my bugs", completed: false });
          //   xhr.onload = () => {
          //     if (xhr.readyState == 4 && xhr.status == 201) {
          //       console.log(JSON.parse(xhr.response));
          // let d = JSON.parse(xhr.response);
          // if (d) {
          //   setResponse({ fileName: d.title, cdnPath: d.title + '.png' })
          // }
          //     } else { console.log(`Error: ${xhr.status}`); }
          //   }; xhr.send(body);
          // } catch (err) { console.log(err) }
          // fetch("https://jsonplaceholder.typicode.com/todos", {
          //   method: "POST",
          //   body: JSON.stringify({
          //     userId: 1,
          //     title: "Fix my bugs",
          //     completed: false
          //   }),
          //   headers: {
          //     "Content-type": "application/json; charset=UTF-8"
          //   }
          // })
          //   .then((response) => response.json())
          //   .then((json) => {
          //     console.log(json)
          //     fs = [{
          //       cdnPath: 'asd',
          //       fileName: 'asdasdsad'
          //     }]
          //   });

        }

        // var data = "{\r\n    \"sms_list\": [\r\n        {\r\n            \"mobile\": 1234567890\r\n        }\r\n    ]\r\n}";

        // var xhr = new XMLHttpRequest();
        // xhr.withCredentials = true;

        // xhr.addEventListener("readystatechange", function () {
        //   if (this.readyState === 4) {
        //     console.log(this.responseText);
        //   }
        // });

        // xhr.open("POST", "https://apisit.piramal.com/v1/recruitment-module/events-test");
        // xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        // xhr.setRequestHeader("client_id", "MAzJk37emMnUuebhNCdetAqTDJqwABZu");
        // xhr.setRequestHeader("client_secret", "p6p73vFTjWGajXqO");
        // xhr.setRequestHeader("grant_type", "client_credentials");
        // xhr.setRequestHeader("Authorization", "Bearer mOD35feNMSGIyh550A4jn3eLWx0F");

        // xhr.send(data);

        function setResponse(savedObject) {
          console.log(savedObject)
          let attach = {}
          if (savedObject) {
            // cr.notification_srv.success(serverData['message'], 'Close', 3000);
            attach[cr.save_filename] = savedObject['fileName'];
            attach[cr.save_cdnpath] = savedObject['cdnPath'];
            // attach['width'] = this.result_dimentions[0].width
            // attach['height'] = this.result_dimentions[0].height
            cr.result = [attach]
            try {
              if (cr.form_group && cr.form_group.controls[cr.extra_control_name]) {
                cr.form_group.controls[cr.extra_control_name].patchValue(savedObject['fileName'])
                cr.form_group.controls[cr.form_control].patchValue(savedObject['fileName'])
              }
              else {
                cr.form_group.get([cr.form_control]).patchValue([attach]);
              }
              cr.uploadStatus.emit(true)
              cr.uploadingStatus = 0

              cr.returnFiles.emit({
                result: [attach], result_dimentions: cr.result_dimentions
              })
            }
            catch (err) {
              console.log(err)
            }
          }
          else {
            // cr.notification_srv.error(res && res['message'], 'Close', 3000);
            cr.returnFiles.emit({
              result: cr.result,
              result_dimentions: cr.result_dimentions
            })
          }
        }
        // eval(this.shortCode.validationScriptUI.mandatory_with_eval)
      }
      else {

        this.file_service.convertFilesToBase64(files).subscribe(res => {
          let all_files = res as any;
          let cr = this;
          let server_cdnpath = this.server_cdnpath;
          let server_filename = this.server_filename;
          all_files.forEach(f => {
            if (!(this.file_size_validation && this.file_size_validation.unit && this.file_size_validation.size)) {
              this.file_size_validation = {
                "unit": "MB",
                "size": "10"
              }
            }
            if (!this.all_supported && this.supported_files && this.supported_files.length) {
              if (this.supported_files.findIndex(data => data == f.extension.toLowerCase()) > -1) {

                if (f.size < (convertToBytes(this.file_size_validation))) {
                  valid_files.push(f);
                }
                else {
                  this.notification_srv.error('File size must be less than ' + this.file_size_validation.size + ' ' + this.file_size_validation.unit, 'Close', 5000);
                }
              }
              else {
                this.notification_srv.error((f.fileName ? f.fileName : f.extension + ' file type is') + ' ' + 'not supported.' + ' Supported file types:-' + this.supported_files.toString(), 'Close', 5000);
              }
            }
            else {
              if (f.size < (convertToBytes(this.file_size_validation))) {
                valid_files.push(f);
              }
              else {
                this.notification_srv.error('File size must be less than' + this.file_size_validation.size + ' ' + this.file_size_validation.unit, 'Close', 5000);
              }
            }

          })
          this.imageChangedEvent = valid_files;
          this.selected_files = valid_files || [];
          if (!this.manual_upload) {
            if (this.selected_files && this.selected_files.length) {
              if (!this.multiple) {
                this.result = this.selected_files || [];
                this.uploadStatus.emit(false);
                let f = this.file_service.makeFormDataFile(this.result[0]);
                let form_data = new FormData();
                form_data.append('attachment', f, f.name)
                this.uploadingStatus = 1;
                this.uploadStatus.emit(false);
                if (this.resume_parser) {
                  this.file_service.resumeParser(form_data).subscribe(res => {
                    if (res && res['data']) {
                      try {
                        this.returnFiles.emit({
                          parser_data: res['data']
                        })
                      }
                      catch (err) {
                      }
                    }
                  })
                  this.notification_srv.success('FILES.uploading_attachments', 'Close', 3000);
                  this.file_service.uploadAttachment(form_data, "1").subscribe(res => {

                    let attach = {}
                    if (res && res['data']) {
                      // this.notification_srv.success(res['message'], 'Close', 3000);
                      attach[this.save_filename] = res['data'][this.server_filename];
                      attach['fileName'] = res['data'][this.server_filename];
                      attach[this.save_cdnpath] = res['data'][this.server_cdnpath];
                      attach['cdnPath'] = res['data'][this.server_cdnpath];
                      // attach['width'] = this.result_dimentions[0].width
                      // attach['height'] = this.result_dimentions[0].height
                      this.result = [attach]
                      try {
                        if (this.form_group && this.form_group.controls[this.extra_control_name]) {
                          this.form_group.controls[this.extra_control_name].patchValue(res['data'][this.server_filename])
                          this.form_group.controls[this.form_control].patchValue(res['data'][this.server_cdnpath])
                        }
                        else {
                          this.form_group.get([this.form_control]).patchValue([attach]);
                        }
                        this.uploadStatus.emit(true)
                        this.uploadingStatus = 0
                        this.returnFiles.emit({
                          result: [attach],
                          result_dimentions: this.result_dimentions
                        })
                      }
                      catch (err) {
                        console.log(err)
                      }
                    }
                    else {
                      // this.notification_srv.error(res && res['message'], 'Close', 3000);
                      this.returnFiles.emit({
                        result: this.result,
                        result_dimentions: this.result_dimentions
                      })
                    }

                  })
                }
                else {

                  this.notification_srv.success('FILES.uploading_attachments', 'Close', 3000);
                  this.file_service.uploadAttachment(form_data, "1").subscribe(res => {

                    let attach = {}
                    if (res && res['data']) {
                      this.notification_srv.success(res['message'], 'Close', 3000);
                      attach[this.save_filename] = res['data'][this.server_filename];
                      attach[this.save_cdnpath] = res['data'][this.server_cdnpath];
                      // attach['width'] = this.result_dimentions[0].width
                      // attach['height'] = this.result_dimentions[0].height
                      this.result = [attach]
                      try {
                        if (this.form_group && this.form_group.controls[this.extra_control_name]) {
                          this.form_group.controls[this.extra_control_name].patchValue(res['data'][this.server_filename])
                          this.form_group.controls[this.form_control].patchValue(res['data'][this.server_cdnpath])
                        }
                        else {
                          this.form_group.get([this.form_control]).patchValue([attach]);
                        }
                        this.uploadStatus.emit(true)
                        this.uploadingStatus = 0

                        this.returnFiles.emit({
                          result: [attach],
                          result_dimentions: this.result_dimentions
                        })
                      }
                      catch (err) {
                        console.log(err)
                      }
                    }
                    else {
                      this.notification_srv.error(res && res['message'], 'Close', 3000);
                      this.returnFiles.emit({
                        result: this.result,
                        result_dimentions: this.result_dimentions
                      })
                    }

                  })


                }

                // var data = "{\r\n    \"sms_list\": [\r\n        {\r\n            \"mobile\": 1234567890\r\n        }\r\n    ]\r\n}";

                // var xhr = new XMLHttpRequest();
                // xhr.withCredentials = true;

                // xhr.addEventListener("readystatechange", function () {
                //   if (this.readyState === 4) {
                //     console.log(this.responseText);
                //   }
                // });

                // xhr.open("POST", "https://apisit.piramal.com/v1/recruitment-module/events-test");
                // xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
                // xhr.setRequestHeader("client_id", "MAzJk37emMnUuebhNCdetAqTDJqwABZu");
                // xhr.setRequestHeader("client_secret", "p6p73vFTjWGajXqO");
                // xhr.setRequestHeader("grant_type", "client_credentials");
                // xhr.setRequestHeader("Authorization", "Bearer mOD35feNMSGIyh550A4jn3eLWx0F");

                // xhr.send(data);
              }
              else {
                // if (this.result && this.result.length) {
                //   this.result = [...this.result, ...this.selected_files];
                // }
                // else {
                //   this.result = [];
                //   this.result = [...this.result, ...this.selected_files];
                // }
                this.uploadStatus.emit(false)
                this.uploadingStatus = 1;
                if (this.selected_files && this.selected_files.length) {
                  this.file_service.saveAttachments(this.selected_files, 1).subscribe(res => {

                    let data: any = res;
                    if (data && data.length) {
                      data.forEach(file => {
                        file[this.save_filename] = file[this.server_filename];
                        file[this.save_cdnpath] = file[this.server_cdnpath];
                        delete (file[this.server_cdnpath])
                        delete (file[this.server_filename])
                      })
                      if (this.result && this.result.length) {
                        this.result = [...this.result, ...data];
                      }
                      else {
                        this.result = [];
                        this.result = [...data];
                      }
                      if (this.form_group && this.form_group.get([this.form_control])) {
                        this.form_group.get([this.form_control]).patchValue(this.result);
                      }
                      this.uploadStatus.emit(true)
                      this.uploadingStatus = 0

                      this.returnFiles.emit(
                        {
                          result: this.result,
                          result_dimentions: this.result_dimentions
                        })
                    }
                    else {
                      this.uploadStatus.emit(true)
                      this.uploadingStatus = 0
                      this.returnFiles.emit(
                        {
                          result: this.result,
                          result_dimentions: this.result_dimentions
                        })
                    }

                  })
                }


              }
            }
          }
          else {
            this.result = this.selected_files;
            if (this.selected_files && this.selected_files.length) {
              this.returnFiles.emit({ result: this.selected_files, actualFiles: files })
            }
          }


        })
      }



    }
    else {
      this.notification_srv.error('ERROR.please_wait_while_attachments_being_uploaded', 'Close', 5000)
    }
  }

  calculatePosition() {
    let top = document.getElementById(this.id).getBoundingClientRect().top;
    let left = document.getElementById(this.id).getBoundingClientRect().left;
    this.container_width = document.getElementById(this.id).offsetWidth;
    if (top > window.innerHeight / 2) {
      this.top = top - 97;
      this.is_display_top = 1;
    }
    else {
      this.is_display_top = 0;
      this.top = document.getElementById(this.id).getBoundingClientRect().top + 34;
    }
    // if (left + 300 > (window.innerWidth)) {
    //   if (this.width) {
    //     this.left = window.innerWidth - 325 + 120;

    //   }
    //   else {
    //     this.left = window.innerWidth - 325;

    //   }
    // }
    // else {
    //   this.left = left;
    // }
    if (left > (window.innerWidth / 2)) {
      if (this.is_display_top) {
        this.left = window.innerWidth - 325 - this.container_width - 186;
      }
      else {
        this.left = window.innerWidth - 325;

      }
    }
    else {
      if (this.is_display_top) {
        this.left = left + this.container_width;
      }
      else {
        this.left = left
      }
    }

  }

  parseAgain() {
    if (this.result && this.result.length) {
      if (this.result[0][this.save_cdnpath] && this.result[0][this.save_cdnpath] != '') {
        this.file_service.getDocxBase64(
          this.result[0][this.save_cdnpath]
        ).subscribe(res => {
          if (res && res['data']) {
            let f = this.makeFormDataFile(res['data'])
            let form_data = new FormData();
            form_data.append('attachment', f, f.name)
            // this.notification_srv.success('FILES.uploading_attachments', 'Close', 3000);
            // this.uploadingStatus = 1;
            // this.uploadStatus.emit(false);
            this.file_service.resumeParser(form_data).subscribe(res => {
              if (res && res['data']) {
                try {
                  this.returnFiles.emit({
                    parser_data: res['data']
                  })
                }
                catch (err) {
                }
              }
            })

          }
        })
      }
    }
  }

  makeFormDataFile(file) {
    try {
      if (file) {
        let base64 = (file.filedata);
        let file_title = (file.filename);
        let mime_type = (file.mimeType);
        function dataURLtoFile(dataurl, filename) {

          var arr = dataurl.split(','),
            // mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[0]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }

          return new File([u8arr], filename, { type: '' });
        }
        let formatted_file = dataURLtoFile(base64, file_title);
        return formatted_file;
      }
    }
    catch (err) {
      console.log(err)
    }

  }

  view(item?) {
    viewDocument(this.result, item, this.dialog, null, this.save_filename, this.save_cdnpath);
  }

  readImageFile(file, i?) {
    let image: any = file
    if (file) {
      let fr = new FileReader();
      let width;
      let height;
      fr.onload = () => { // when file has loaded
        var img = new Image();

        img.onload = () => {
          this.width = img.width;
          this.height = img.height;
          this.result_dimentions[i] = {
            width: this.width, height: this.height
          }
        };

        img.src = fr.result as string; // This is the data URL
      };

      fr.readAsDataURL(image);
    }


  }

  removeFile(file) {
    this.dialog.open(ConfirmationComponent, {
      width: '30%',
      height: 'auto',
      data: {
        title: 'CONFIRMATION.confirmation',
        message: 'CONFIRMATION.are_you_sure_to_delete',
        message1: file.fileName + ' ',
      }
    }).afterClosed().subscribe(res => {
      if (res) {
        let index = this.result.indexOf(file);
        if (index > -1) {
          this.result.splice(index, 1);
        }
      }
    })

  }

  downloadFile(letter) {
    this.file_service.saveFileFromURL(letter['cdnPath'], letter['fileName'])
    // fs.saveAs(storage_url + letter.cdnPath, letter.fileName);
    // let link = document.createElement("a");
    // link.setAttribute('download', letter.fileName);
    // link.href = storage_url + letter.cdnPath;
    // document.body.appendChild(link);
    // link.click();
    // link.remove();
  }

  downloadInstructions(file_arr, instruction) {

    this.dialog.open(ConfirmationComponent, {
      width: '30%',
      height: 'auto',
      data: {
        title: 'CONFIRMATION.confirmation',
        message: 'OFFER.are_you_sure_to_proceed',
      }
    }).afterClosed().subscribe(res => {
      if (res) {
        if (true) {
          console.log(instruction);
          console.log(this.field_deatails);
          let t_id = Math.round(Date.now() + Math.random() * 10000000);
          let obj = {
            templateCode: this.field_deatails.fieldCode,
            genFromInstructionDoc: 1,
            alertId: this.alertId,
            threadId: t_id
          }
          instruction.downloadMsg = 'Generating document...'
          this.onb_svc.generateOnbAppointmentLetter(obj, '2').subscribe(res => {
            // if (res && res['data'] && res['data'].latestData) {
            instruction.downloadMsg = null;
            if (res?.['data']?.latestData?.length) {
              try {
                this.downloadFile(res['data'].latestData[0]);
                instruction.successMsg = res?.['message'];
              }
              catch (err) {
                console.log(err);

              }
            }
            else {
              this.notificationSubscription(instruction, t_id);
            }

            // this.downloadFile(res['data'].latestData[0]);

            // }
          })
        }
        else {
          if (file_arr && file_arr.length && file_arr.length == 1) {
            this.downloadFile(file_arr[0]);
          }
          else if (file_arr && file_arr.length && file_arr.length > 1) {
          }
        }
      }
    })



  }

  firebase_subscription: Subscription;
  notificationSubscription(instruction, t_id) {
    this.firebase_subscription = this.profile_settings_srv.getFirebaseMessage().subscribe(res => {
      if (res && res['data'] && res['data']['body'] && res['data']['body'].latestData && res['data']['body']['templateCode'] == this.field_deatails.fieldCode && res['data']['body']['threadId'] == t_id) {
        try {
          this.downloadFile(res['data']['body'].latestData[0]);
          instruction.downloadMsg = null;
        }
        catch (err) {
          console.log(err);

        }

        try {
          this.firebase_subscription.unsubscribe();
        }
        catch (err) {
          console.log(err);
        }
      }
    })
  }

}



export function convertToBytes(file_size_validation) {
  if (!(file_size_validation && file_size_validation.unit && file_size_validation.size)) {
    file_size_validation = {
      "unit": "MB",
      "size": "10"
    }
  }
  var bytes = 0;
  if (file_size_validation.unit === "KB") {
    bytes = file_size_validation.size * 1024;
  } else if (file_size_validation.unit === "MB") {
    bytes = file_size_validation.size * 1048576;
  }
  return bytes;
}

export function convertToBytesv2(file_size_validation) {
  if (!(file_size_validation && file_size_validation.unit && file_size_validation.size)) {
    file_size_validation = {
      "unit": "MB",
      "size": "10"
    }
  }
  var bytes = 0;
  if (file_size_validation.unit === "KB") {
    bytes = file_size_validation.size * 1024;
  } else if (file_size_validation.unit === "MB") {
    bytes = file_size_validation.size * 1048576;
  }
  return bytes;
}

export function removeItems(array1, array2, selector1, selector2) {
  const ids = array2.map(item => item[selector2]);
  const filteredArray = array1.filter(item => !ids.includes(item[selector1]));
  return filteredArray;
}
